// extracted by mini-css-extract-plugin
export default {"projectForm":"style_projectForm__t3+HT","button":"style_button__yTfnT"};